import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { app } from "../../firebase";
import image from "./image11.jpg";
import "./Login.css"; // Import your custom styles here

const auth = getAuth(app);

const LoginForm = ({ theme }) => {
    const [formData, setFormData] = useState({
        email: "",
        password: "",
    });

    const navigate = useNavigate();

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        loginuser();
    };

    const loginuser = () => {
        signInWithEmailAndPassword(auth, formData.email, formData.password)
            .then(() => {
                alert("Login successful");
                // Redirect to AboutUs page using navigate
                navigate("/home");
            })
            .catch((error) => {
                console.error("Error logging in:", error.message);
                alert("Error logging in: " + error.message);
            });
    };

    return (
        <div className={`container ${theme}`} style={{ minHeight: '100vh', position: 'relative', backgroundImage: `url(${image})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
            <div className="row justify-content-center align-items-center" style={{ minHeight: '100vh', position: 'relative', zIndex: 1 }}>
                <div className="col-md-6 col-lg-4">
                    <div className={`card ${theme === 'dark' ? 'dark-mode' : 'light-mode'}`} style={{ backgroundColor: theme === 'dark' ? 'rgba(0, 0, 0, 0.9)' : 'rgba(255, 255, 255, 0.9)' }}>
                        <div className="card-body">
                            <h2 className={`card-title text-center ${theme === 'dark' ? 'text-white' : 'text-dark'}`}>Login</h2>
                            <form onSubmit={handleSubmit}>
                                <div className="mb-3">
                                    <label htmlFor="email" className={`form-label ${theme === 'dark' ? 'text-white' : 'text-dark'}`}>
                                        Email
                                    </label>
                                    <input
                                        type="text"
                                        className={`form-control ${theme === 'dark' ? 'text-white' : 'text-dark'}`}
                                        id="email"
                                        name="email"
                                        placeholder="Write Your Email here"
                                        value={formData.email}
                                        onChange={(e) => handleInputChange(e)}
                                        required
                                        style={{ backgroundColor: theme === 'dark' ? 'black' : 'white', color: 'black', '::placeholder': { color: theme === 'dark' ? 'white' : 'black' } }}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="password" className={`form-label ${theme === 'dark' ? 'text-white' : 'text-dark'}`}>
                                        Password
                                    </label>
                                    <input
                                        type="password"
                                        className={`form-control ${theme === 'dark' ? 'text-white' : 'text-dark'}`}
                                        id="password"
                                        name="password"
                                        placeholder="Write Your Password"
                                        value={formData.password}
                                        onChange={(e) => handleInputChange(e)}
                                        required
                                        style={{ backgroundColor: theme === 'dark' ? 'black' : 'white', color: 'black', '::placeholder': { color: theme === 'dark' ? 'white' : 'black' } }}
                                    />
                                </div>
                                <button type="submit" className={`btn btn-block ${theme === 'dark' ? 'btn-light' : 'btn-dark'}`} style={{marginLeft:"0%",fontWeight:"bold"}}>
                                    Submit
                                </button>
                            </form>

                            <p className={`text-center mt-3 ${theme === 'dark' ? 'text-white' : 'text-dark'}`}>
                                No account? <Link to="/signup" style={{fontWeight:"bold",textDecoration:"none"}}>SignUp</Link>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginForm;
